import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material/";
import LoadingButton from "@mui/lab/LoadingButton";
import Stepper from "./Stepper";
import { ActionBar } from "../../common/components";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import actions from "../../Store/actions";
import styles from "./styles";
import { checkSteps, excludeSteps, createNewStep, addNewSteps } from "./steps";
import useAssetJourneyHelpers from "./useAssetJourneyHelpers";
import ExcludeMany from "./ExcludeAsset/ExcludeMany";
import { useParams } from "react-router-dom";
import ExcludeAsset from "./ExcludeAsset";

const AssetJourney = ({
    actionBtnUpdate,
    assetMode,
    loading,
    hdlCheckAsset,
    hdlExcludeAsset,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { assetId } = useParams();
    const isExcludeMany = !assetId;

    const {
        isStepComplete,
        disableCheck,
        disabledExclude,
        disabledUpdateAsset,
        showSteppers,
    } = useAssetJourneyHelpers(actionBtnUpdate, assetMode);

    const { assetDetails } = useSelector((state) => state);
    const [showButtons, setShowButtons] = useState(false);

    const { steps, activeStep, stepsCompleted, photos } = assetDetails;

    useEffect(() => {
        let updSteps = checkSteps;

        // On exclude mode change the label to add photo
        // If the exclusion reason is selected previously clear the label
        if (assetMode.includes("exclude")) {
            updSteps = excludeSteps;
            updSteps[activeStep + 1].label = t("addPhoto");
        }
        if (assetMode === "updatechecked") {
            updSteps = addNewSteps;
        }
        if (assetMode === "unchecked") {
            updSteps = checkSteps;
        }

        // initialise number of steps to be completed
        const imgSteps = steps.filter((item) => item.isImage);

        dispatch(
            actions.assetDetails.create.set({
                steps: updSteps,
                photos: new Array(imgSteps.length).fill({}),
                stepsCompleted: new Array(updSteps.length).fill(false),
            })
        );
    }, [assetMode]);

    // Update new step with new step when new image is added
    useEffect(() => {
        /** If all the steps have photos then add new step with the image */
        if (isStepComplete) {
            const newStep = createNewStep(
                steps.length,
                photos.length,
                assetMode
            );
            const newSteps = [...steps, newStep];
            const newStepsCompleted = [...stepsCompleted, false];

            dispatch(
                actions.assetDetails.create.set({
                    ...assetDetails,
                    steps: newSteps,
                    stepsCompleted: newStepsCompleted,
                })
            );
        }
    }, [isStepComplete]);

    // Cleanup for assetDetails
    useEffect(() => {
        // cleanup
        return () => {
            dispatch(actions.assetDetails.create.clear());
        };
    }, []);

    /** generate button based on the condition */
    const generateButton = (loading, hdlClick, disabledBtn, text) => (
        <LoadingButton
            variant="contained"
            loading={loading}
            onClick={hdlClick}
            sx={styles.loadingBtn}
            disabled={disabledBtn}
            disableElevation
        >
            {text}
        </LoadingButton>
    );

    // wait until mode and steps are set

    return steps.length === 0 && !isExcludeMany ? null : (
        <>
            <Box sx={styles.wrapStepper}>
                {assetMode.includes("exclude") > 0 && (
                    <>
                        {isExcludeMany ? (
                            <ExcludeMany />
                        ) : (
                            <>
                                <ExcludeAsset />
                            </>
                        )}
                    </>
                )}
                {!isExcludeMany && showSteppers && <Stepper />}
            </Box>
            {isExcludeMany && assetDetails.excludeAssetsStep == 2 && (
                <ActionBar>
                    <Grid container spacing={2} sx={styles.actionGrid}>
                        <Grid
                            item
                            xs={12}
                            sx={{ pl: "0 !important", pt: "0 !important" }}
                        >
                            {assetDetails.excludeAssetsStep == 2 &&
                                generateButton(
                                    loading,
                                    hdlExcludeAsset,
                                    disabledExclude,
                                    t("excludeAsset")
                                )}
                        </Grid>
                    </Grid>
                </ActionBar>
            )}
            {!isExcludeMany && (
                <ActionBar>
                    <Grid container spacing={2} sx={styles.actionGrid}>
                        <Grid
                            item
                            xs={12}
                            sx={{ pl: "0 !important", pt: "0 !important" }}
                        >
                            {assetMode.includes("exclude")
                                ? generateButton(
                                      loading,
                                      hdlExcludeAsset,
                                      disabledExclude,
                                      t("excludeAsset")
                                  )
                                : generateButton(
                                      loading,
                                      hdlCheckAsset,
                                      assetMode === "updatechecked"
                                          ? disabledUpdateAsset
                                          : disableCheck,
                                      assetMode === "updatechecked"
                                          ? t("updateAsset")
                                          : t("checkAsset")
                                  )}
                        </Grid>
                    </Grid>
                </ActionBar>
            )}
        </>
    );
};

export default AssetJourney;

{
    /* TODO
 1. Date picker test case to Asset Delivered To Customer And Not Paid 
 */
}
